import { connect } from "react-redux";
import SignalREnrollTenant from "./SignalREnrollTenant";
import { updateStep } from "store/environments/tenants/enroll-tenant/enroll-tenant-actions";
import { RootState } from "store/store";

const mapStateToProps = (state: RootState) => {
    return {
        orchestratorInstanceId:
            state.enrollTenantReducer.orchestratorInstanceId,
    };
};

const SignalREnrollTenantContainer = connect(mapStateToProps, {
    updateStep,
})(SignalREnrollTenant);

export default SignalREnrollTenantContainer;
